import { render, staticRenderFns } from "./TypeCascader.vue?vue&type=template&id=5aaff75e"
import script from "./TypeCascader.vue?vue&type=script&lang=js"
export * from "./TypeCascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports